/*!
 * Created by netlogix GmbH & Co. KG.
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { AbstractControl, ValidationErrors } from '@angular/forms';

export function autocompleteOptionSelectedValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value !== null && typeof control.value === 'object') {
    return null;
  }
  return { autoCompleteActionSelected: false };
}
